import { Box, useCombobox } from "@mantine/core";

import { ListTablePageSizeLabel } from "./components";

import { Dropdown } from "@/components/elements/Dropdown";

import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type ListTablePageSizeChangerProps = {
  label?: string;
  onChange: (page: number) => void;
  presets?: number[];
  pageSize: number;
} & MantineStyleProps;

export const ListTablePageSizeChanger: FC<ListTablePageSizeChangerProps> = ({
  label,
  onChange,
  presets = [10, 25, 50, 75],
  pageSize,
  ...props
}) => {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  return (
    <Box>
      <Dropdown
        allowDeselect={false}
        clearable={false}
        data={presets.map((preset) => ({
          children: <ListTablePageSizeLabel label={label} size="sm" value={preset} />,
          value: String(preset),
        }))}
        iconVariant="transparent"
        onChange={(value) => onChange(Number(value))}
        optionProps={{ gap: "md", justify: "space-between", w: "100%" }}
        value={String(pageSize)}
        variant="check"
        {...props}
      />
    </Box>
  );
};
